"use client";
import g, { useState as I, useMemo as r, useCallback as x } from "react";
import "./index.es73.js";
import "./index.es74.js";
import "./index.es75.js";
import "./index.es76.js";
import "./index.es77.js";
import "./index.es78.js";
import "./index.es79.js";
import "./index.es80.js";
import "./index.es81.js";
import { createRules as G } from "./index.es82.js";
import "./index.es83.js";
import "./index.es84.js";
import "./index.es85.js";
import "./index.es86.js";
import "./index.es87.js";
import "./index.es88.js";
import "./index.es89.js";
import "./index.es90.js";
import "./index.es91.js";
import "./index.es92.js";
import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import { getDimensionInfo as L, getStatisticsSettings as R } from "./index.es97.js";
import _ from "./index.es98.js";
const $ = (t) => "groups" in t && Array.isArray(t.groups) && t.groups.length ? t.groups[0].title : void 0, F = (t, e) => Array.isArray(t) ? t.find((n) => n.groupTitle === e) : t, mt = ({
  data: t,
  options: e,
  content: n,
  file: S,
  blockId: d
}) => {
  const [p, k] = I(
    $(t)
  ), l = r(() => "groups" in t && Array.isArray(t.groups) ? t.groups.map((o) => o.title) : [], [t]), T = r(
    () => "groupsTitle" in t ? t.groupsTitle : "datasett",
    [t]
  ), i = r(
    () => F(e, p),
    [e, p]
  ), c = r(() => "groups" in t && Array.isArray(t.groups) ? t.groups.find((o) => o.title === p) : t, [p, t]), a = r(
    () => c?.data,
    [c]
  ), s = r(
    () => a ? L(a) : [],
    [a]
  ), f = r(
    () => s ? s.map((o) => o.name) : [],
    [s]
  ), m = r(
    () => i ? G(i.rules, f) : void 0,
    [i, f]
  ), y = r(
    () => i && m && s ? R(
      i.initialSettings,
      m,
      s
    ) : void 0,
    [i, m, s]
  ), A = r(
    () => i?.unitOptions,
    [i]
  ), b = r(
    () => i?.chartOptions,
    [i]
  ), h = r(
    () => i?.dimensionLabels,
    [i]
  ), v = r(
    () => i?.annotations || [],
    [i]
  ), O = r(() => {
    const o = Array.isArray(e) ? e.find((u) => u.title)?.title : "";
    return i?.title || o || n?.title || "";
  }, [i, n, e]), C = r(() => {
    const o = Array.isArray(e) ? e.find((u) => u.subtitle)?.subtitle : "";
    return i?.subtitle || o;
  }, [i, e]), D = x(
    (o) => {
      l.includes(o) && k(o);
    },
    [l]
  ), E = !!a && !!m && !!y && !!A && !!b && !!h && !!d;
  return /* @__PURE__ */ g.createElement(g.Fragment, null, E && /* @__PURE__ */ g.createElement(
    _,
    {
      rootDimension: a,
      rules: m,
      initialSettings: y,
      annotations: v,
      unitOptions: A,
      chartOptions: b,
      dimensionLabels: h,
      group: p,
      groupNames: l,
      groupsTitle: T,
      content: n,
      file: S,
      blockId: d,
      title: O,
      subtitle: C,
      onGroupChange: D
    }
  ));
};
export {
  mt as default
};
//# sourceMappingURL=index.es42.js.map
